import FirestoreDataClass from "./_baseClasses";

export default class ImageMap extends FirestoreDataClass {
  static collectionName = "image_maps";
}
